import {
  CookieIcon,
  DiscordLogoIcon,
  InstagramLogoIcon,
  LinkedInLogoIcon,
  LockClosedIcon,
  ReaderIcon,
  TwitterLogoIcon,
} from "@radix-ui/react-icons"
import { Link, RedditLogoIcon, TelegramLogoIcon } from "@sundae/ui-toolkit"
import { initiateClient } from "client-theme"

import clientTranslations, { TClientTranslationType } from "./translations"

import "./styles.scss"

initiateClient<TClientTranslationType>({
  brand: {
    buttons: {
      primary: { className: "!text-black !rounded-full" },
      secondary: { className: "!text-black !rounded-full" },
    },
    logos: {
      header: (
        <Link to="/">
          <img src="/static/logo-black.png" className="h-6 dark:hidden" />
          <img src="/static/logo-white.png" className="hidden h-6 dark:block" />
        </Link>
      ),
      notFound: <></>,
    },
  },
  enableBgGradient: false,
  clientNamespace: "wmt",
  clientTranslations,
  externalRoutes: {
    faq: "https://worldmobile.io/help",
    protocol: "https://worldmobile.io/the-chain",
  },
  routes: [
    {
      path: "https://worldmobile.io/about/our-manifesto",
      i18nKey: "about",
    },
    {
      path: "https://worldmobile.io/the-chain",
      i18nKey: "chain",
    },
  ],
  quickMenuPopover: (currentLocale) => [
    {
      title: clientTranslations[currentLocale].quickMenu.discord,
      icon: <DiscordLogoIcon />,
      link: "https://discord.gg/worldmobile",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.twitter,
      icon: <TwitterLogoIcon />,
      link: "https://twitter.com/WorldMobileTeam/",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.telegram,
      icon: <TelegramLogoIcon className="h-4 w-4" />,
      link: "https://t.me/WorldMobileTeam",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.instagram,
      icon: <InstagramLogoIcon />,
      link: "https://www.instagram.com/WorldMobileTeam/",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.linkedin,
      icon: <LinkedInLogoIcon />,
      link: "https://www.linkedin.com/company/worldmobilegroup/",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.reddit,
      icon: <RedditLogoIcon />,
      link: "https://www.reddit.com/r/worldmobile/",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.privacy,
      icon: <LockClosedIcon />,
      link: "https://worldmobile.io/privacy",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.cookies,
      icon: <CookieIcon />,
      link: "https://worldmobile.io/cookies",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.terms,
      icon: <ReaderIcon />,
      link: "https://worldmobile.io/terms-and-conditions",
    },
  ],
})
